import messages from "../messages/messages.js";
import {SparklesIcon, QueueListIcon, UserCircleIcon} from "@heroicons/react/24/solid";

export function AccountDetail() {
    return (
        <div
            className="w-full border border-border/60 bg-zinc-800 rounded-lg shadow-sm md:mt-0 sm:max-w-md xl:p-0 self-start">
            <div className="p-6 sm:p-8 space-y-4 md:space-y-6">
                <h2>Enjoy more features by creating an account!</h2>
                <ul className=" space-y-3 list-inside text-gray-400">
                    <li className="flex items-center">
                        <SparklesIcon className="h-5 w-5 text-yellow-400 mr-2"/>
                        <span>Access to exclusive features</span>
                    </li>
                    <li className="flex items-center">
                        <QueueListIcon className="h-5 w-5 text-blue-400 mr-2"/>
                        <span>Create and manage playlists</span>
                    </li>
                    <li className="flex items-center">
                        <UserCircleIcon className="h-5 w-5 text-green-400 mr-2"/>
                        <span>Personalized recommendations</span>
                    </li>
                </ul>
                <div className="flex items-center">
                    <a href="/subscribe" className="primary-btn text-xm text-center">Subscribe</a>
                    <span className="ml-4 text-gray-400 text-sm">To unlock even more!</span>
                </div>
            </div>
        </div>
    )
}